module.exports = __webpack_public_path__ + "static/img/google-g.87a88114.svg";